import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Neige = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77.87 88.92">
  <G fill={color}>
    <Path d="M76.26,62.3l-9.84-5.68,6.12-1.64c1.72-.46,2.73-2.22,2.27-3.94-.46-1.72-2.22-2.74-3.94-2.27l-12.33,3.3-13.18-7.61,13.18-7.61,12.33,3.3c.28.08.56.11.83.11,1.42,0,2.72-.95,3.1-2.38.46-1.72-.56-3.48-2.27-3.94l-6.12-1.64,9.84-5.68c1.54-.89,2.07-2.85,1.18-4.39-.89-1.54-2.85-2.07-4.39-1.18l-9.84,5.68,1.64-6.12c.46-1.72-.56-3.48-2.27-3.94-1.71-.46-3.48.56-3.94,2.27l-3.3,12.33-13.18,7.61v-15.22l9.03-9.03c1.26-1.26,1.26-3.29,0-4.55-1.26-1.26-3.29-1.26-4.55,0l-4.48,4.48V3.22c0-1.78-1.44-3.22-3.22-3.22s-3.22,1.44-3.22,3.22v11.36l-4.48-4.48c-1.26-1.26-3.29-1.26-4.55,0-1.26,1.26-1.26,3.29,0,4.55l9.03,9.03v15.22l-13.18-7.61-3.3-12.33c-.46-1.72-2.22-2.74-3.94-2.27-1.72.46-2.73,2.22-2.27,3.94l1.64,6.12-9.84-5.68c-1.54-.89-3.5-.36-4.39,1.18-.89,1.54-.36,3.5,1.18,4.39l9.84,5.68-6.12,1.64c-1.72.46-2.73,2.22-2.27,3.94.38,1.44,1.68,2.38,3.1,2.38.28,0,.56-.04.83-.11l12.33-3.3,13.18,7.61-13.18,7.61-12.33-3.3c-1.71-.46-3.48.56-3.94,2.27-.46,1.72.56,3.48,2.27,3.94l6.12,1.64-9.84,5.68c-1.54.89-2.07,2.85-1.18,4.39.6,1.03,1.68,1.61,2.79,1.61.55,0,1.1-.14,1.6-.43l9.84-5.68-1.64,6.12c-.46,1.72.56,3.48,2.27,3.94.28.08.56.11.83.11,1.42,0,2.72-.95,3.1-2.38l3.3-12.33,13.18-7.61v15.22l-9.03,9.03c-1.26,1.26-1.26,3.29,0,4.55,1.26,1.26,3.29,1.26,4.55,0l4.48-4.48v11.36c0,1.78,1.44,3.22,3.22,3.22s3.22-1.44,3.22-3.22v-11.36l4.48,4.48c.63.63,1.45.94,2.27.94s1.65-.31,2.27-.94c1.26-1.26,1.26-3.29,0-4.55l-9.03-9.03v-15.22l13.18,7.61,3.3,12.33c.38,1.44,1.68,2.38,3.1,2.38.28,0,.56-.04.83-.11,1.72-.46,2.73-2.22,2.27-3.94l-1.64-6.12,9.84,5.68c.51.29,1.06.43,1.6.43,1.11,0,2.19-.58,2.79-1.61.89-1.54.36-3.5-1.18-4.39Z"/>
  </G>
</Svg>
);
};

export default Neige;
